import { render, staticRenderFns } from "./OnboardingHeader.vue?vue&type=template&id=5d2a0bdc&scoped=true"
import script from "./OnboardingHeader.vue?vue&type=script&lang=ts"
export * from "./OnboardingHeader.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingHeader.vue?vue&type=style&index=0&id=5d2a0bdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a0bdc",
  null
  
)

export default component.exports